import $ from "jquery"

export default {
  init(selector, config) {
    
  },
  finalize() {

    $('#racgp_member').on('change', function() {
            if ($(this).is(':checked')) {
                $("#racgp_number").show();
            }else{
                $("#racgp_number").hide(); 
                $("#racgp_number").html();
            }
    });

    $('#prefix').on('change', function () { // TODO This stopped working
        var prefixselected = $(this).find(":selected").text();
        if(prefixselected == 'Other'){
            $('#other_prefix').show();
        }else{
            $('#other_prefix').hide(); 
            $('#other_prefix').html();
        }
    });

},

};


// WEBPACK FOOTER //
// ./scripts/routes/generate-event-certificate.js